import React, {useContext, useEffect, useMemo, useState} from 'react';
import {connect} from 'react-redux';
import {
  batchLookupImg,
  individualLookupImg,
} from '../../../assets/images/images';
import * as Actions from '../../../store/actions';
import {PAGES_URL} from '../../../helpers/constants';
import {PageContext} from '../../../helpers/context';
import Layout from '../HomeLayout';
import {PerformBtn, ViewLink} from '../../../components/lookupComponents';
import {getLighterShade} from 'routes/EasyOnboard/colorUtils';

import SingleIndividualLookupModal from '../Modals/SingleIndividualLookupModal';
import BatchIndividualLookupModal from '../Modals/BatchIndividualLookupModal';

function IndividualLookup({auth: {userDetails}}) {
  const [openIndividualLookup, setOpenIL] = useState(false);
  const [openBatchLookup, setOpenBL] = useState(false);
  const baseColor = userDetails?.company?.color_code || '#3f7cdb';
  const lighterShade = getLighterShade(baseColor, 96);
  const {setPageName} = useContext(PageContext);
  useEffect(() => {
    setPageName('lookup');
  }, [setPageName]);

  const {
    performSingleIndividualLookup,
    viewSingleIndividualLookup,
    performBatchIndividualLookup,
    viewBatchIndividualLookup,
  } =
    useMemo(() => userDetails?.permissions?.lookupPermissions, [userDetails]) ||
    {};

  const isCompanyVerified = userDetails?.company?.verified;

  return (
    <Layout>
      <SingleIndividualLookupModal
        open={openIndividualLookup}
        setOpen={setOpenIL}
      />

      <BatchIndividualLookupModal open={openBatchLookup} setOpen={setOpenBL} />

      <div className="flex flex-col mt-6 sm:flex-row items-stretch gap-10 sm:gap-4 lg:gap-10">
        <div
          style={{
            backgroundColor: lighterShade,
            borderColor: 'rgba(230, 240, 255, 0.5)',
          }}
          className="rounded-xl pb-0 gap-2 flex flex-col items-start sm:max-w-[406px] w-full border"
        >
          <div className="py-8 px-6 w-full">
            <h2 className="text-deepBlue mb-1 text-lg font-semibold">
              Perform Single lookup
            </h2>
            <p className="text-[#8E90A9] w-full border tracking-[-0.01em] border-transparent text-base font-light">
              Verify your user identity with ease
            </p>
            <div className="w-full flex flex-col mt-8 lg:flex-row items-start lg:items-center gap-2">
              <PerformBtn
                btnText="Perform Single lookup"
                permitted={performSingleIndividualLookup}
                setOpen={setOpenIL}
                isCompanyVerified={isCompanyVerified}
              />
              <ViewLink
                permitted={viewSingleIndividualLookup}
                route={PAGES_URL.INDIVIDUAL_LOOKUP_SINGLE}
              />
            </div>
          </div>
          <div className="flex justify-center w-full">
            <img
              src={individualLookupImg}
              alt=""
              className="w-full p-2 rounded-xl"
            />
          </div>
        </div>

        <div
          style={{
            backgroundColor: lighterShade,
            borderColor: 'rgba(230, 240, 255, 0.5)',
          }}
          className="rounded-xl pb-0 gap-2 flex flex-col items-start sm:max-w-[406px] w-full border"
        >
          <div className="py-8 px-6 w-full">
            <h2 className="text-deepBlue mb-1 text-lg font-semibold">
              Perform Batch lookup{' '}
            </h2>
            <p className="text-[#8E90A9] w-full border tracking-[-0.01em] border-transparent text-base font-light">
              Upload and verify multiple users seamlessly
            </p>
            <div className="w-full flex flex-col mt-8 lg:flex-row items-start lg:items-center gap-2">
              <PerformBtn
                btnText="Perform Batch lookup"
                permitted={performBatchIndividualLookup}
                setOpen={setOpenBL}
                isCompanyVerified={isCompanyVerified}
              />
              <ViewLink
                permitted={viewBatchIndividualLookup}
                route={PAGES_URL.INDIVIDUAL_LOOKUP_BATCH}
              />
            </div>
          </div>
          <div className="rounded-xl flex justify-center w-full">
            <img
              src={batchLookupImg}
              alt=""
              className="w-full p-2 rounded-xl"
            />
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default connect(state => state, Actions)(IndividualLookup);
